// ActionLayout — category-based two-panel layout for action routes.
// Delegates to the shared CategoryLayout component.

import { CategoryLayout, useSelectedCategory } from '@/components/features/category-selection-tree'

// Re-export under the domain-specific name for backward compatibility
export { useSelectedCategory as useSelectedActionCategory }

export function ActionLayout() {
  return (
    <CategoryLayout
      categoryType="action"
      domainPath="actions"
      heading="Action Categories"
    />
  )
}
